import { z } from 'zod';
import { defineEndpoint } from '../contract.ts';
import { GuildRole } from '../discord/base.ts';

// The guild's roles for the admin panel (plan 1C Assumption 15), read through the
// worker and cached for 60 s. With no worker connected: 503 discord_unavailable,
// and the panel falls back to raw ids.

export const listDiscordRoles = defineEndpoint({
  method: 'GET',
  path: '/admin/discord/roles',
  permission: 'core.admin.groups',
  response: z.object({ roles: z.array(GuildRole), fetchedAt: z.iso.datetime() }),
});
